import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCloudArrowDown16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCloudArrowDown16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m12.9 7.615-.064.539.416.348c.467.39.748.95.748 1.562 0 1.114-.957 2.092-2.23 2.092H4.23c-1.273 0-2.23-.978-2.23-2.092 0-.758.433-1.442 1.118-1.813l.607-.329-.092-.684a2 2 0 0 1-.018-.266c0-1.114.957-2.091 2.231-2.091q.183 0 .356.026l.443.066.344-.285a3.68 3.68 0 0 1 2.357-.838c2.018 0 3.577 1.554 3.577 3.38q0 .196-.023.385m-1.13 5.54H4.23c-1.784 0-3.23-1.383-3.23-3.091 0-1.155.662-2.162 1.642-2.693a3 3 0 0 1-.027-.399c0-1.707 1.447-3.091 3.231-3.091q.258 0 .505.037A4.68 4.68 0 0 1 9.346 2.85c2.528 0 4.577 1.961 4.577 4.38q0 .256-.03.504A3.03 3.03 0 0 1 15 10.064c0 1.707-1.447 3.092-3.23 3.092M5.878 7.923a.5.5 0 0 0 0 .707l1.768 1.768.353.353.354-.353 1.768-1.768a.5.5 0 1 0-.708-.707l-.914.914V6.5a.5.5 0 1 0-1 0v2.336l-.914-.914a.5.5 0 0 0-.707 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCloudArrowDown16);
